<template>
  <v-form
    ref="form"
    lazy-validation
  >
    <v-card>
      <v-card-title v-if="title">
        <span class="text-h3">{{ $t(title) }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-if="authUser.isAdmin"
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.product"
                dense
                :disabled="type == 'edit'"
                :items="['cso']"
                item-text="name"
                item-value="id"
                :label="$t('select_product_*')"
                :rules="[rules.required]"
                @change="tenantList"
              />
            </v-col>
            <v-col
              v-if="authUser.isAdmin"
              cols="6"
              sm="6"
            >
              <v-autocomplete
                v-model="options.tenant_id"
                dense
                :loading="tenantLoading"
                :items="
                  options.product
                    ? options.product == 'oem'
                      ? tenantsOEM
                      : tenantsCSO
                    : []
                "
                :disabled="type == 'edit'"
                item-text="name"
                item-value="id"
                :label="$t('select_tenant_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.location_id"
                dense
                :disabled="readOnly"
                :loading="locationLoading"
                :items="options.tenant_id ? locationsList : []"
                item-value="id"
                item-text="name"
                :label="$t('select_location_*')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-autocomplete
                v-model="options.charge_station"
                dense
                :disabled="readOnly"
                :loading="isCharge"
                :items="options.location_id ? chargeStationsList : []"
                item-value="charge_station_id"
                item-text="charge_point_id"
                :label="$t('select_charge_station_*')"
                :rules="[rules.required]"
              >
                <!-- selected -->
                <!-- <template v-slot:selection="data">
                  <span
                    v-if="data.index === 0"
                    class="selected"
                  >
                    <span>{{ data.item?.charge_point_id }}</span>
                  </span>
                  <span
                    v-if="data.index === 1"
                    class="grey--text text-caption"
                  >
                    (+{{ options?.charge_station_id.length - 1 }} others)
                  </span>
                </template> -->
                <!-- selected -->
              </v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="options.cso_client"
                dense
                :disabled="readOnly"
                :loading="isClient"
                :items="options.tenant_id ? csoClientList : []"
                item-value="id"
                item-text="business_name"
                :label="$t('select_cso_client_*')"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small v-if="!readOnly">{{ $t("indicates_required_field") }}</small>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="closeForm()"
        >
          Close
        </v-btn>
        <v-btn
          v-if="!readOnly"
          color="primary"
          text
          :loading="loading"
          @click="saveItem"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  mixins: [validationRules],

  props: {
    type: {
      type: String,
      default() {
        return {
          time: null,
        };
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    readOnly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tenantOEM: [],
      options: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      tenantLoading: "tenantsManagement/getIsLoading",
      tenantsList: "tenantsManagement/getTenantOptions",
      tenantsOEM: "tenantsManagement/getTenantsOEM",
      tenantsCSO: "tenantsManagement/getTenantsCSO",
      //
      locationLoading: "csmsLocations/getLoading",
      locationsList: "csmsLocations/getList",
      isCharge: "csmsChargeStations/getLoading",
      chargeStationsList: "csmsChargeStations/getChargers",
      isClient: "csoClients/getLoading",
      csoClientList: "csoClients/getList",
    }),
    title() {
      if (this.readOnly) {
        return "view";
      }
      if (this.type == "create") {
        return "add_new";
      } else if (this.type == "edit") {
        return "edit";
      } else {
        return "";
      }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: async function (val) {
        if (this.type == "create") this.fetchDependents(val);
        if (val) {
          await this.$store.dispatch("csoClients/list", { tenant_id: val });
        }
      },
    },
    "options.location_id": {
      handler: async function (val) {
        delete this.options.charge_station_id;
        if (val) {
          this.getChargeStation();
        }
      },
    },
  },
  async mounted() {
    if (this.type == "create") {
      if (!this.authUser.isAdmin) {
        this.options.tenant_id = this.authUser.tenant_id;
        this.fetchDependents(this.authUser.tenant_id);
      }
      // this.options.currency = "PKR";
    }

    if (this.type == "edit") {
      this.options = { ...this.item };
      await this.$store
        .dispatch("csmsLocations/list", {
          tenant_id: this.options.tenant_id,
        })
        .then(() => {
          if (this.options.location_id) {
            const arr = this.locationsList.find(
              (r) => r.id == this.options.location_id
            );
            this.options.latitude = arr?.latitude;
            this.options.longitude = arr?.longitude;
          }
        });
      await this.$store.dispatch("csmsRates/list", {
        tenant_id: this.options.tenant_id,
      });
    }
  },
  beforeDestroy() {
    this.$store.commit("csmsChargeStations/SET_CHARGERS", []);
  },
  methods: {
    tenantList() {
      if (this.product == "oem") {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "oem");
      } else {
        this.tenantOEM = this.tenantsList.filter((r) => r.product == "cso");
      }
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        const opt = { ...this.options };
        this.$emit("onsave", opt);
      }
    },
    closeForm() {
      // this.$refs.form.reset();
      this.$emit("onclose");
    },

    async fetchDependents(tId) {
      // delete this.options.location_id;
      delete this.options.latitude;
      delete this.options.longitude;
      await this.$store
        .dispatch("csmsLocations/list", {
          tenant_id: tId,
        })
        .then(() => {
          if (this.options.location_id) {
            const arr = this.locationsList.find(
              (r) => r.id == this.options.location_id
            );
            this.options.latitude = arr?.latitude;
            this.options.longitude = arr?.longitude;
          }
        });
    },

    getChargeStation() {
      this.$store.dispatch("csmsChargeStations/chargerList", this.options);
    },
    //
  },
};
</script>
<style lang="sass" scoped>
.connectorsRow

  display: flex
  gap:1rem
  .field
    min-width:150px !important
    max-width:165px !important


.deleteButton
  cursor: pointer
  .deleteIcon
    &:hover
      color: red
</style>
